import { Zone } from '@modules/zones/model';
import { HttpError, HttpTask } from '@core/http';
import * as ZonesService from '@modules/zones/service';
import * as TE from 'fp-ts/TaskEither';

export function getZoneDetailNullable(id: Zone.Id | null): HttpTask<Zone> {
  return id ? ZonesService.getZone(id) : TE.left(HttpError.notFound);
}
